import React, { useEffect, useState } from 'react';
import './preview-landing-page.styles.scss';
import UnauthLayout from '@/components/layout-unauth/unauth-layout.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDice, faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PreviewManagerLanding from '../preview-manager/preview-manager-landing.component';
import { previewUserContent } from '../previewGameData';
import { setCurrentUser, setMembership, setUserProfile } from '@/state/slices/userSlice';
import ChoosePlayerModal from './choose-player-modal.component';
import PreviewPlayerLanding from '../preview-player/preview-player-landing.component';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';

const PreviewLandingPage = () => {

  const currentUser = useSelector(state => state.userData.currentUser);
  const screenSize = useSelector(state => state.contentData.screenSize);
  const [ displayPlayerModal, setDisplayPlayerModal ] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const gamePath = 'previewgame';

  useEffect(() => {
    changeDocumentTitle('Gamably Preview');

    return () => {
      dispatch(setCurrentUser(null));
      dispatch(setUserProfile(null));
      dispatch(setMembership(null));
    }
  }, [])

  useEffect(() => {
    if (!currentUser || currentUser.uid === "preview-manager" || currentUser.uid === "preview-player") return;
    navigate('/logout?redirectUrl=/preview');
  }, [currentUser]);

  function sendToPreviewGame() {
    navigate(`/preview/manager/${gamePath}`);
  }

  return (
    <div className={`preview-landing-container ${screenSize}`}>
      <Routes>
        <Route path='' element={
          <UnauthLayout>
            <div className="preview-landing-page">

              <div className='g-card preview-landing-page-content'>
                <h1>Preview Gamably as a Game Manager or Player</h1>
                <p>Explore the features and capabilities of our platform before signing up.</p>

                <div className='preview-buttons'>
                  <button
                    className='g-button preview-button'
                    onClick={() => sendToPreviewGame()}>
                    <FontAwesomeIcon icon={faScrewdriverWrench} size="2x" />
                    Preview as a Game Manager
                  </button>
                  <button
                    className='g-button preview-button'
                    onClick={() => setDisplayPlayerModal(true)}>
                    <FontAwesomeIcon icon={faDice} size="2x" />
                    Preview as a Player
                  </button>
                </div>
              </div>

            </div>
          </UnauthLayout>
        }></Route>
        <Route path='/manager/:gamePath/*' element={
          <PreviewManagerLanding />
        }></Route>
        <Route path='/player/:gamePath/*' element={
          <PreviewPlayerLanding />
        }></Route>
      </Routes>
      <ChoosePlayerModal
        show={displayPlayerModal}
        cancel={() => setDisplayPlayerModal(false)} />
    </div>
  )
}

export default PreviewLandingPage